/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropdrawseed2Inputs */

const en_dropdrawseed2 = /** @type {(inputs: Dropdrawseed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draw random value`)
};

const de_dropdrawseed2 = /** @type {(inputs: Dropdrawseed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zufallswert der Ziehung`)
};

/**
* | output |
* | --- |
* | "Draw random value" |
*
* @param {Dropdrawseed2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropdrawseed2 = /** @type {((inputs?: Dropdrawseed2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropdrawseed2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropdrawseed2(inputs)
	return de_dropdrawseed2(inputs)
});
export { dropdrawseed2 as "dropDrawSeed" }